import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const GetWishList = createAsyncThunk(
  "getWishlistData/getWishList",
  async (_, thunkAPI) => {
    try {
      const storedUuid = localStorage.getItem("uuid");
      const Token = localStorage.getItem("loginData");
      const response = await axios.get(endPoint.GETWISHLIST, {
        headers: {
          sessionId: storedUuid ? storedUuid : "",
          Authorization: Token ? `Bearer ${Token}` : "",
        },
      });
      return response.data;
    } catch (error) {
      console.error(
        "Error fetching wishlist:",
        error.response?.data || error.message
      );
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const GetWishListSlice = createSlice({
  name: "GetWishListData",
  initialState: {
    GetWishListData: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetWishList.fulfilled, (state, action) => {
        state.GetWishListData = action.payload;
      })
      .addCase(GetWishList.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const deleteWishList = createAsyncThunk(
  "cartData/deleteCartItem",
  async (productId, thunkAPI) => {
    try {
      const Token = localStorage.getItem("loginData");
      const storedUuid = localStorage.getItem("uuid");
      await axios.delete(endPoint.REMOVEWISHLIST, {
        data: { productId: productId },
        headers: {
          sessionId: storedUuid ? storedUuid : "",
          Authorization: Token ? `Bearer ${Token}` : "",
        },
      });
      thunkAPI.dispatch(GetWishList());
      return { productId };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export default GetWishListSlice.reducer;
